module.exports = {
  participant: 'participant',
  observer: 'observer',
};
